import angular from 'angular';
import template from './qrModal.html';

class ModalFormController {

    $onInit() {
    }

    cancel() {
        this.dismiss({$value: 'cancel'});
    };

    onQrCode(content) {
        this.close({$value: content});
    }
}

const ModalQrFormComponent = {
    restrict: 'E',
    templateUrl: template,
    controller: ModalFormController,
    controllerAs: 'vm',
    bindings: {
        resolve: '<',
        close: '&',
        dismiss: '&'
    }
};


export {ModalQrFormComponent};



// WEBPACK FOOTER //
// ./app/components/common/qrCodeScanner/qrModal.component.js